// Firebase singletons — the application's only connection to Firebase Auth and
// Firebase Data Connect (Cloud SQL Postgres `fdcdb`). We talk directly to these
// services: no backend URLs, no fetch shim, no sync layer.
//
// `initializeApp` is guarded so re-importing this module (HMR, tests) never
// throws "app already exists". The web `apiKey` is a public client identifier,
// not a secret, so it lives in source by design.
import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getDataConnect, type DataConnect } from 'firebase/data-connect';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { connectorConfig } from '@eskom-parcc/dataconnect';

const firebaseConfig = {
  apiKey: 'AIzaSyDOxHSIQLfXWb0bf-1jiTvLlcU-SlZ9dbo',
  // Custom auth domain (Google sign-in redirect/JS origins configured for it).
  authDomain: 'parcc.kettleconsulting.co.za',
  projectId: 'eskom-parcc',
  storageBucket: 'eskom-parcc.firebasestorage.app',
  messagingSenderId: '299731637919',
  appId: '1:299731637919:web:98f62bad2523f2ab86b4aa',
};

export const app: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const dc: DataConnect = getDataConnect(connectorConfig);
// Cloud Storage — avatars (owner-write, signed-in read) and generated reports
// (admin-only). Access is gated by storage.rules; the SDK carries the caller's
// verified ID token, so reads/writes are authenticated, not public-by-link.
export const storage: FirebaseStorage = getStorage(app);
